import type { RootState } from 'state';
import type { AirportGroupingsState } from '../slice';

function getDestinationAirportGroupings(state: RootState): AirportGroupingsState['destinationGroupings'] {
  const { destinationGroupings } = state.dataService.airports.airportGroupings;
  return destinationGroupings;
}

export default getDestinationAirportGroupings;
